module.exports = __webpack_public_path__ + "img/photozone-2.7d2be7cd.jpg";